import { useRef, useState } from "react";

export const useOtpInput = (length = 6) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const inputRefs = useRef([]);

  // Spreads one or more digits (typed, pasted or SMS-autofilled) from `index` onwards.
  const fill = (value, index) => {
    const digits = String(value).replace(/\D/g, "").slice(0, length - index).split("");
    setOtp((prev) => {
      const next = [...prev];
      if (!digits.length) next[index] = "";
      digits.forEach((d, i) => (next[index + i] = d));
      return next;
    });
    const target = Math.min(index + digits.length, length - 1);
    if (digits.length && inputRefs.current[target]) inputRefs.current[target].focus();
  };

  const handleChange = (element, index) => {
    // The box already holds a digit, so a new keystroke appends; keep only what was added.
    const value = element.value.length > 1 && otp[index] ? element.value.replace(otp[index], "") : element.value;
    fill(value, index);
  };

  const handlePaste = (e, index) => {
    e.preventDefault();
    fill(e.clipboardData.getData("text"), index);
  };

  const handleKeyDown = (element, index) => {
    if (element.key === "Backspace" && otp[index] === "" && inputRefs.current[index - 1]) {
      inputRefs.current[index - 1].focus();
    }
  };

  return { otp, setOtp, inputRefs, handleChange, handleKeyDown, handlePaste };
};
